import React, { useEffect } from "react";
import LabelWithInput from "@components/input/LabelWithInput";
import { useForm, useFormContext } from "react-hook-form";
import BasicFormInput from "@components/input/BasicFormInput";
import FadeInContainer from "@components/motion/FadeInContainer";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "4rem",
});

const Description = styled.div(({ theme }) => ({
  color: theme.color.gray,
  lineHeight: "12px",
  fontSize: "1.2rem",
}));

const ErrorMessage = styled.div(({ theme }) => ({
  color: theme.color.orange,
  fontSize: "1.2rem",
}));

const ProductNameInput = () => {
  const {
    watch,
    trigger,
    formState: { errors },
  } = useFormContext();

  const { t } = useTranslation();

  const brand_id = watch("brand_id");
  const name_ko = watch("name_ko");
  const brand_name = watch("brand_name");

  useEffect(() => {
    if (name_ko) {
      trigger("name_ko");
    }
  }, [name_ko, trigger]);

  const isShow = brand_id !== null && (brand_id !== 0 || brand_name !== "");

  return (
    <Container>
      <FadeInContainer isShow={isShow}>
        <LabelWithInput label="상품명 (국문)" required>
          <BasicFormInput
            name="name_ko"
            placeholder="상품명을 입력해주세요. (최대 100자)"
            max={100}
          />
          {errors?.name_ko && (
            <ErrorMessage>{errors?.name_ko?.message?.toString()}</ErrorMessage>
          )}
        </LabelWithInput>
      </FadeInContainer>

      <FadeInContainer isShow={isShow}>
        <LabelWithInput label="상품명 (영문)">
          <BasicFormInput
            name="name_en"
            placeholder="상품명을 입력해주세요. (최대 100자)"
            max={100}
          />

          <Description>
            {t(
              "번역된 버전에서는 영문으로 표시되며, 영문 설명이 없는 경우 국문으로 표시됩니다.",
            )}
          </Description>
        </LabelWithInput>
      </FadeInContainer>
    </Container>
  );
};

export default ProductNameInput;
